module.exports = {"230709009":"爱民社区","230709010":"新建社区","230709011":"育林社区","230709012":"文明社区","230709013":"金山社区","230709401":"白山林场","230709402":"丰岭林场","230709403":"丰林林场","230709404":"丰沟经营所","230709405":"丰茂林场","230709406":"横山经营所","230709407":"丰丽林场","230709408":"大昆仑经营所","230709409":"小昆仑林场","230709410":"育林经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230709.json
// module id = 748
// module chunks = 0